import { ZoomIn } from '@mui/icons-material'
import { FC, useState} from 'react'
import { useTranslation } from 'react-i18next'

interface IProps {
  handleSearch: any
}

const TopSearch: FC<IProps> = ({handleSearch}) => {

  const { t } = useTranslation()
  const [inputValue, setInputValue] = useState("")
  
  return (
    <>
      <div className="top-search">
        <div className="top-search-input">
          <div style={{ flexGrow: 1 }}>
            <input
              value={inputValue}
              
              onChange={event => setInputValue(event.target.value)}
              type="text" 
              placeholder={t('dashboard.ask-me-anything')}
              />
          </div>
          <div>
            <ZoomIn sx={{ cursor: 'pointer', fontSize: '40px'}} onClick={() => {
              handleSearch(inputValue)
            }}/>
          </div>
        </div>  
      </div>


    </>
  )
}

export default TopSearch
